/**
 * Validation constants for bank account information
 * Based on Silverton Save AutoPay API requirements
 */

export const AUTOMATIC_PAYMENTS_SETUP_CONSTANTS = {
  // Routing number validation: 9 digits
  ROUTING_NUMBER: {
    PATTERN: /^[0-9]{9}$/,
    MIN_LENGTH: 9,
    MAX_LENGTH: 9,
    ERROR_MESSAGE: 'Routing number must be 9 digits',
  },

  // Account number validation: 4-12 digits
  ACCOUNT_NUMBER: {
    PATTERN: /^[0-9]{4,12}$/,
    MIN_LENGTH: 4,
    MAX_LENGTH: 12,
    ERROR_MESSAGE: 'Account number must be between 4 and 12 digits',
  },

  // Page configuration
  PAGE_CONFIG: {
    POLICY_SELECTION: 'policySelection',
    ACCOUNT_TYPE: 'accountType',
    ROUTING_NUMBER: 'routingNumber',
    ACCOUNT_NUMBER: 'accountNumber',
    WITHDRAWAL_DATE: 'withdrawalDate',
    WITHDRAWAL_FREQUENCY: 'withdrawalFrequency',
    CONSENT_REVIEWED: 'consentReviewed',
    CONSENT_AGREE: 'consentAgree',
  },

  // Account types available
  ACCOUNT_TYPES: {
    PERSONAL_SAVINGS: {
      value: '0',
      label: 'Personal Savings',
    },
    PERSONAL_CHECKING: {
      value: '1',
      label: 'Personal Checking',
    },
    CORPORATE_BUSINESS_ACCOUNT: {
      value: '2',
      label: 'Corporate Business Account',
    },
  },

  // Withdrawal dates (days of month)
  WITHDRAWAL_DATES: Array.from({ length: 28 }, (_, i) => i + 1),

  // Withdrawal frequencies
  WITHDRAWAL_FREQUENCIES: {
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    SEMI_ANNUAL: 'Semi-Annual',
    ANNUAL: 'Annual',
  },

  // API endpoints
  API: {
    ENROLL_AUTOPAY: '/member/v1/route/payment/active/automatic-payments-setup',
  },
};

export const AUTOMATIC_PAYMENTS_POLICIES = {
  FLEXIBLE_CHOICE_DENTAL: {
    value: 'flexible-choice-dental',
    label: 'Flexible Choice Dental, Vision and Hearing',
  },
  LUMP_HEART_STROKE: {
    value: 'lump-heart-stroke',
    label: 'Lump Heart and Stroke',
  },
};

export const AUTOMATIC_PAYMENTS_ERROR_MESSAGES = {
  POLICY_REQUIRED: 'Please select at least one policy',
  ACCOUNT_TYPE_REQUIRED: 'Account type is required',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_REQUIRED: 'Last name is required',
  ASSIGNEE_FIRST_NAME_REQUIRED: 'Authorized assignee first name is required',
  ASSIGNEE_LAST_NAME_REQUIRED: 'Authorized assignee last name is required',
  ROUTING_NUMBER_REQUIRED: 'Routing number is required',
  ROUTING_NUMBER_INVALID:
    'Routing number must be 9 digits and pass bank checksum validation',
  ACCOUNT_NUMBER_REQUIRED: 'Account number is required',
  ACCOUNT_NUMBER_INVALID: 'Account number must be between 4 and 12 digits',
  WITHDRAWAL_DATE_REQUIRED: 'Required withdrawal date is required',
  WITHDRAWAL_FREQUENCY_REQUIRED: 'Required withdrawal frequency is required',
  CONSENT_REVIEWED_REQUIRED: 'Please confirm you have reviewed the information',
  CONSENT_AGREE_REQUIRED: 'Please agree to the terms',
  API_ERROR: 'Unable to process your autopay enrollment. Please try again later.',
  INVALID_ACCOUNT_OR_ROUTING:
    'The routing number or account number provided is invalid. Please verify and try again.',
  ACCOUNT_DETAILS_NOT_RECOGNIZED:
    'The account details you entered were not recognized. Please recheck your account details and try again.',
  TOO_MANY_FAILED_ATTEMPTS:
    'Too many unsuccessful attempts. Please wait a few minutes before trying again.',
  NETWORK_OR_SYSTEM_ERROR:
    "We're sorry, we can't update your payment method at this time. Please try again.",
};
